import React from 'react';
import { TruckTrendChart } from '../Charts/TrucksTrendChart';

const TrucksTrend = ({ data = [], selectedMonth, selectedYear }) => {
  const jobTypes = ["Paving", "Dirt Hauling", "Gravel Supply"];
  const cssVarStartIndex = 15;

  const getColor = (index) => {
    const variable = `--cd${cssVarStartIndex + index}`;
    return getComputedStyle(document.documentElement)
      .getPropertyValue(variable)
      .trim();
  };

  const formattedData = data.map(item => ({
    ...item,
    label: `${item.month} ${item.year}`,
  }));

  const titleMonth = selectedMonth || new Date().toLocaleString('default', { month: 'long' });
  const titleYear = selectedYear || new Date().getFullYear();
  const hasData = formattedData.some(item => item.count > 0);

  return (
    <div className="white-wraper extra-mt">
      <h2 className="add-margin">
        Job Distribution ({titleMonth} {titleYear})
      </h2>
      {/* Chart */}
      <div className="chart-canvas2">
        {hasData ? (
          <>
            <div className='piechart-cover'>
              <TruckTrendChart data={formattedData} />
            </div>
            <div className='piechart-content'>
              <div className='piecontent-inner'>
                <ul>
                  <li>
                    <div className="chart-dot piechart-dot1"></div>
                    <p>Paving</p>
                  </li>
                  <li>
                    <div className="chart-dot piechart-dot2"></div>
                    <p>Dirt Hauling</p>
                  </li>
                  <li>
                    <div className="chart-dot piechart-dot3"></div>
                    <p>Gravel Supply</p>
                  </li>
                </ul>
              </div>
            </div>
          </>
        ) : (
          <div
            className="text-center text-secondary"
            style={{ paddingTop: "4rem", paddingBottom: "4rem" }}
          >
            No data available
          </div>
        )}
      </div>
    </div>
  );
};

export default TrucksTrend;
